import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box
} from '@mui/material';

const ContractLinkExpired: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box my={4}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Contract Link Expired
          </Typography>
          <Typography variant="body1" paragraph>
            This contract link is no longer active. If you need assistance, please contact your counsellor.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            For security reasons, contract links can only be used once and expire after completion.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default ContractLinkExpired;
